function indexInParent(node) {
    var children = node.parentNode.childNodes;
    var num = 0;
    for (var i=0; i<children.length; i++) {
         if (children[i]==node) return num;
         if (children[i].nodeType==1) num++;
    }
    return -1;
}

const CLASS_DISABLED = 'disabled';
const CLASS_ACTIVE = 'active';
const CLASS_SIBLING_ACTIVE = 'active-sibling';

function initPagination(pagination) {
    let activeItem = pagination.querySelector('.active')
    if (typeof(activeItem) != 'undefined' && activeItem != null) {
        let initIndex = indexInParent(pagination.querySelector('.active'));

        pagination.setAttribute('data-index' , initIndex);

        let paginationItem = pagination.querySelectorAll("li:not(.prev, .next)");
        if(paginationItem.length < 10){
            return
        }else{
            pagination.classList.add('truncated');
            pagination.querySelector(".prev").addEventListener("click", function (event) { navigateSinglePage(event); } , false);
            pagination.querySelector(".next").addEventListener("click", function (event) { navigateSinglePage(event); } , false);

            function paginationItemClick(e , data_index) {
                let itemParent = e.currentTarget.closest('.sj--pagination');
                console.log(itemParent.getAttribute('data-index'));
                itemParent.setAttribute('data-index' , data_index);
                changePage(itemParent);
            }

            for (let i = 0; i < paginationItem.length; i++) {
                let data_index = indexInParent(paginationItem[i]);
                paginationItem[i].addEventListener('click', function (event) {  paginationItemClick(event , data_index); } , false);
            }
        }
    }
}

function navigateSinglePage(event) {
    if (!event.currentTarget.classList.contains(CLASS_DISABLED)) {
        let itemParent = event.currentTarget.closest(".sj--pagination");
        let data_index = itemParent.getAttribute('data-index');
        let active_index = parseInt(data_index, 10);
        let change_by = 1;

        if(event.currentTarget.classList.contains("prev")){
            active_index += change_by * -1;
            data_index = active_index;
        } else {
            active_index += change_by * 1;
            data_index = active_index;
        }

        itemParent.setAttribute('data-index' , data_index);

        changePage(itemParent);
    }
}

function changePage(paginationParent) {
    let paginationItems = paginationParent.querySelectorAll("li:not(.prev, .next)");
    let data_index = paginationParent.getAttribute('data-index');
    let active_index = parseInt(data_index, 10) - 1;
    let target_index = active_index + 2;
    let sibling_index = target_index - 1;
    let activeItem = paginationParent.querySelector("." + CLASS_ACTIVE);
    let activeSiblingItem = paginationParent.querySelector("." + CLASS_SIBLING_ACTIVE);
    let targetItem = paginationParent.querySelector("li:nth-child(" + target_index + ")")

    if(typeof(activeItem) != 'undefined' && activeItem != null){
        activeItem.classList.remove(CLASS_ACTIVE);
    }

    if(typeof(activeSiblingItem) != 'undefined' && activeSiblingItem != null){
        activeSiblingItem.classList.remove(CLASS_SIBLING_ACTIVE);
    }

    for (let i = 0; i < paginationItems.length; i++) {
        if(i == active_index){
            if(typeof(targetItem) != 'undefined' && targetItem != null){
                targetItem.classList.add(CLASS_ACTIVE)
            }
        }
    }
    if (data_index <= 1) {
        paginationParent.querySelector(".prev").classList.add(CLASS_DISABLED);
    } else {
        paginationParent.querySelector("li:nth-child(" + sibling_index + ")").classList.add(CLASS_SIBLING_ACTIVE);
        paginationParent.querySelector(".prev").classList.remove(CLASS_DISABLED);
        
    }

    if (data_index == paginationItems.length) {
        paginationParent.querySelector(".next").classList.add(CLASS_DISABLED);
    } else {
        paginationParent.querySelector(".next").classList.remove(CLASS_DISABLED);
    }
}

document.arrive('.sj--pagination', { existing: true }, function() {
    let paginationContainers = document.querySelectorAll(".sj--pagination");
    for (let i = 0; i < paginationContainers.length; i++) {
        initPagination(paginationContainers[i]);
    }
});